import { useQuery } from '@tanstack/react-query';

import { getBannerDisplay, getClaimLicensesByUser, getStateSummary } from 'api/claims-license';
import type { ClaimLicenseByUserParams } from 'types/claim-license';

import { HOUR_IN_MILLISECONDS } from 'utils/constants';

export const getStateSummaryQueryKey: any[] = ['state-summary'];
export const getBannerDisplayQueryKey: any[] = ['banner-display'];
export const getClaimLicensesByUserQueryKey = ['claim-licenses-by-user'];

export const useClaimLicensesByUserQuery = (payload: ClaimLicenseByUserParams, overrides = {}) =>
  useQuery({
    queryKey: [...getClaimLicensesByUserQueryKey, payload],
    queryFn: () => getClaimLicensesByUser(payload),
    ...overrides,
  });

export const useClaimLicenseStateSummaryQuery = () =>
  useQuery({
    queryKey: getStateSummaryQueryKey,
    queryFn: getStateSummary,
  });

export const useClaimLicenseBannerDisplayQuery = (userId, overrides = {}) =>
  useQuery({
    queryKey: getBannerDisplayQueryKey.concat(userId),
    queryFn: getBannerDisplay,
    staleTime: HOUR_IN_MILLISECONDS,
    ...overrides,
  });
